<template>
  <div class="padded" style="text-align: left;">

    <edit-pane v-if="!hidePanel"
      ref="ep"
      prefix="Equipment:"
      :title="equip.name"
      :editable="isTelco() ? false : (isManager('project|maintenance|finance|admin') && !stepFrozen)"
      :is-edit="!disabled"
      @save="onSave"
      @cancel="onCancel"
      @edit="onEdit"
      @add="onSave" />


  <el-row :gutter="12">

    <el-col v-if="canAccess('project|maintenance|finance|admin') && isTowerCo() && (isDesktop || isTablet)" :lg="4">
      <h5>Features</h5>
    </el-col>

      <el-col v-if="canAccess('project|maintenance|finance|admin') && isTowerCo()" :xs="12" :sm="12" :md="6" :lg="3">
        <switch-input v-model="equip.isMaint" label="Maint." :disabled="disabled" no-form />
      </el-col>

        <el-col v-if="canAccess('project|maintenance|finance|admin') && isTowerCo()" :xs="12" :sm="12" :md="6" :lg="3">
          <switch-input v-model="equip.hasDimensions" label="Dim." :disabled="disabled" no-form />
       </el-col>

        <el-col v-if="canAccess('project|maintenance|finance|admin') && isTowerCo()" :xs="12" :sm="12" :md="6" :lg="3">
          <switch-input v-model="equip.onTower" label="On Tower" :disabled="disabled" no-form />
      </el-col>

        <el-col v-if="canAccess('project|maintenance|finance|admin') && isTowerCo()" :xs="12" :sm="12" :md="6" :lg="3">
          <switch-input v-model="equip.usesPower" label="Uses Power" :disabled="disabled" no-form />
      </el-col>

        <el-col v-if="canAccess('project|maintenance|finance|admin') && isTowerCo()" :xs="12" :sm="12" :md="6" :lg="3">
          <switch-input v-model="equip.providesPower" label="Prov. Pwr." :disabled="disabled" no-form />
      </el-col>

      <el-col v-if="canAccess('project|maintenance|finance|admin') && isTowerCo()" :xs="12" :sm="12" :md="6" :lg="3">
        <switch-input v-model="equip.isBillable" label="Billable" :disabled="disabled" no-form />
    </el-col>

  </el-row>

  <el-row :gutter="12">

    <el-col  v-if="canAccess('project|maintenance|finance|admin')" :span="24"> <!-- :sm="24" :md="20" :lg="21" -->

      <el-tabs type="border-card" v-model="tabs">

        <el-tab-pane name="equip-general">
          <template #label><span><i class="fa fa-asterisk"></i><span v-if="isDesktop"> Details </span></span></template>

          <el-form :model="equip" label-position="left" label-width="120px">

            <el-row :gutter="16">

              <el-col :xs="24" :sm="24" :md="adding ? 24 : 18" :lg="adding ? 24 : 18">

                <el-row :gutter="12">

                  <el-col :span="22">
                    <select-equip-category v-model="catType" :disabled="(disabled || !canAccess('project|maintenance|finance'))" />
                  </el-col>

                  <el-col :span="22">
                    <el-alert v-if="adding" show-icon type="error" title="Note!" description="You can add equipment/assets for all sharers, backhaul, tower providers and contractors here. If you need to add equipment for new sharer, create that sharer first." />
                    <select-organisation
                    v-if="this.isTowerCo()"
                    type="Telco,Contractor"
                    label="Owner"
                    v-model="equip.owner_id"
                    :sharer-limits="limits"
                    :disabled="disabled || !canAccess('project|maintenance|finance')" />

                  </el-col>

                  <el-col :span="22">

                    <text-input
                    label="Name"
                    v-model="equip.name"
                    placeholder="Asset name"
                    :disabled="disabled || !canAccess('project|maintenance|finance')"
                    :prefix="equip.name ? 'fa fa-cog' : null"
                    :is-prefix-icon="true"
                    />

                  </el-col>

                  <el-col :span="22">

                    <text-input
                    label="Serial No."
                    v-model="equip.serialNo"
                    placeholder="Serial No."
                    :disabled="disabled || !canAccess('project|maintenance|finance')"
                    :prefix="equip.serialNo ? 'fa fa-barcode' : null"
                    :is-prefix-icon="true"
                    />

                  </el-col>

                  <el-col :xs="24" :md="12" :lg="12">
                    <number-input label="Quantity" v-model="equip.qty" placeholder="Quantity" :disabled="disabled || !canAccess('project|maintenance|finance')" />
                  </el-col>

                  <el-col :xs="24" :md="12" :lg="12">
                    <number-input label="Set #" v-model="equip.setNo" placeholder="Set #" :disabled="disabled || !canAccess('project|maintenance|finance')" />
                  </el-col>

                  <el-col :xs="24" :md="12" :lg="12">
                    <date-input label="Installed Date" v-model="equip.installedOn" placeholder="Installed Date" :disabled="disabled || !canAccess('project|maintenance|finance')" />
                  </date-input>
                </el-col>

              </el-row>

            </el-col>

            <el-col v-if="!adding && isTowerCo()" :span="6" align="center">
              <qr-code :text="qrCode" :color="equip.organisation.colourCode" :label="equip.organisation.shortName" :file-name="fileName" :bw-background="true" />
            </el-col>



          </el-row>

        </el-form>
        </el-tab-pane>


        <el-tab-pane v-if="equip.isMaint && !this.adding && canAccess('project|maintenance|finance')" name="equip-maint">
          <template #label><span><i class="fa fa-wrench"></i><span v-if="isDesktop"> Maintenance</span></span></template>
          <h4>Maintenance</h4>
          <equip-maint :is-edit="!disabled" :row-data="equip" :site-id="siteId" :asset-id="equip.id" ></equip-maint>
        </el-tab-pane>

        <el-tab-pane name="equip-remarks"  v-if="canAccess('project|maintenance|finance') && isTowerCo()">
          <template #label><span><i class="fa fa-comment-alt"></i><span v-if="isDesktop"> Remarks</span></span></template>

          <el-form>
            <html-input :disabled="disabled" v-model="equip.reamrks" />
          </el-form>
        </el-tab-pane>

        <el-tab-pane v-if="!this.adding && canAccess('project|maintenance') && isTowerCo()" name="equip-atach">
          <template #label><span><i class="fa fa-paperclip"></i><span v-if="isDesktop"> Attachments</span></span></template>
          <files-panel type="site" :id="equip.site_id" process="equip" :process-id="equip.id" />
        </el-tab-pane>


        <el-tab-pane v-if="equip.hasDimensions && canAccess('project|maintenance|finance')" name="equip-dim">
          <template #label><span><i class="fa fa-pencil-ruler"></i><span v-if="isDesktop"> Dimensions</span></span></template>
          <h4>Physical Dimensions</h4>

          <dimensions :row-data="equip" :is-edit="!disabled"></dimensions>

        </el-tab-pane>


        <el-tab-pane v-if="equip.onTower && canAccess('project|maintenance|finance')" name="equip-on-tower">
          <template #label><span><i class="fa fa-broadcast-tower"></i><span v-if="isDesktop"> Pos.</span></span></template>
          <h4>On Tower Location</h4>
          <on-tower :is-edit="!disabled" :row-data="equip"></on-tower>
        </el-tab-pane>


        <el-tab-pane v-if="equip.usesPower && canAccess('project|maintenance|finance')"  name="equip-pwr-req">
          <template #label><span><i class="fa fa-battery-half"></i><span v-if="isDesktop"> Pwr. Req</span></span></template>
          <h4>Power Consumption</h4>
          <power :is-edit="!disabled" :row-data="equip"></power>
        </el-tab-pane>


        <el-tab-pane v-if="equip.providesPower && canAccess('project|maintenance')" name="equip-pwr-gen">
          <template #label><span><i class="fa fa-plug"></i><span v-if="isDesktop"> Pwr Gen</span></span></template>
          <h4>Power Generation</h4>
          <power-gen :is-edit="!disabled" :row-data="equip"></power-gen>
        </el-tab-pane>


        <!--
        <el-tab-pane v-if="equip.isAuditable && !this.adding && canAccess('project|maintenance|finance') && isTowerCo()" name="equip-audit">
        <template #label><span><i class="fa fa-calendar-check"></i> Audit</span></template>
        <h4>Audit History</h4>
        <equip-audit :is-edit="!disabled" :row-data="equip" :site-id="siteId" :equip-id="rowData.id" ></equip-audit>
      </el-tab-pane>
    -->

    <el-tab-pane v-if="equip.isBillable && canAccess('finance') && isTowerCo()" name="equip-billable">
      <template #label><span><i class="fa fa-file-invoice-dollar"></i><span v-if="isDesktop"> Billing</span></span></template>
      <h4>Billing Details</h4>
      <billable :is-edit="!disabled" :row-data="equip"></billable>
    </el-tab-pane>


  </el-tabs>
</el-col>
</el-row>

<div v-if="equip.updated_at">
  <hr />
  <span class="pull-right">Last update: <b>{{formatFriendlyDate(equip.updated_at)}}</b> ({{formatDateTime(equip.updated_at)}})<span v-if="equip.updated_by"> by {{equip.updated_by}}</span></span>
</div>

</div>
</template>

<script>



import DateMixins from '@/mixins/DateMixins'
import PostMixins from '@/mixins/PostMixins'

import QrCode from '@/components/atoms/QrCode'
import SelectEquipCategory from '@/components/atoms/selects/SelectEquipCategory'

import Power from '@/components/assets/features/Power'
import PowerGen from '@/components/assets/features/PowerGen'
import EquipMaint from '@/components/assets/EquipMaint'
import OnTower from '@/components/assets/features/OnTower'
import Dimensions from '@/components/assets/features/Dimensions'
import Billable from '@/components/assets/features/Billable'

export default {
  mixins: [DateMixins, PostMixins],

  components: {
    Billable,
    Dimensions,
    EquipMaint,
    Power,
    PowerGen,
    OnTower,
    SelectEquipCategory,
    QrCode
  },

  props: {
    rowData: {
      type: Object,
      default: null
    },

    siteId: {
      type: Number,
      default: null
    },

    ownerId: {
      type: Number,
      default: null
    },

    editMode: {
      type: Boolean,
      default: false
    },

    tableRef: {
      type: String,
      default: 'equiptable'
    },

    adding: {
      type: Boolean,
      default: false
    },

    hidePanel: {
      type: Boolean,
      default: false
    },

    // XOL-596 (completed steps): the request step this equipment is edited from (the
    // `action_steps.id` of step 2, party 1) and whether that step is complete. Sent with every
    // write so the API can refuse it while the step is complete; a site page passes neither.
    actionStepId: {
      type: Number,
      default: null
    },

    stepFrozen: {
      type: Boolean,
      default: false
    }
  },

  methods: {

    getSharerIds (data) {
      this.limits = data
    },

    success (response) {
      // Read-only only once the save is ANSWERED: a refused save must not look saved
      // (XOL-596; the coordinator's finding 2).
      this.disabled = true
      this.$events.emit(this.tableRef + '-refresh-table')
    },

    onCancel () {
      this.disabled = true
    },

    onEdit () {
      this.disabled = false
    },

    onAdd () {
      this.onSave()
    },

    onSaveFail (err) {
      //      this.$message ...
      // A completed step (XOL-596): the form stays as the user left it, and the request
      // drawer says why. Any other failure keeps its own toast.
      this.stepCompletedRefusal(err, this.equip.id ? 'equipmentEdit' : 'equipmentAdd', { actionStepId: this.actionStepId })
    },

    onSave () {
      if (!this.equip.site_id) {
        this.equip.site_id = Number(this.siteId)
      }

      if (!this.equip.owner_id) {
        this.equip.owner_id = this.ownerId ? Number(this.ownerId) : Number(this.org().id)
      }

      this.equip.category = this.catType[0] ? this.catType[0] : null
      this.equip.type = this.catType[1] ? this.catType[1] : null
      this.equip.subType = this.catType[2] ? this.catType[2] : null
      this.equip.variant = this.catType[3] ? this.catType[3] : null

      this.equip.installedOn = this.formatDateSql(this.equip.installedOn)
      this.equip.billingStart = this.formatDateSql(this.equip.billingStart)
      this.equip.billingExpiry = this.formatDateSql(this.equip.billingExpiry)
      this.equip.depositDate = this.formatDateSql(this.equip.depositDate)

      // The step context goes in the body only, never onto the record itself.
      var body = this.actionStepId ? Object.assign({}, this.equip, { actionStepId: this.actionStepId }) : this.equip

      this.saveForm(this, '/assets', this.equip.id, body,
        this.equip.category + (this.equip.type ? ' ' + this.equip.type : ''),
        this.success,
        this.onSaveFail,
        true, null, true
      )
    },

    onClose () {
    },

    deleteAsset () {
      this.deleteItem(this, this.equip.id, '/assets', this.equip.category + ' ' + this.equip.name, this.onDelete,
        true, null, 'Yes', this.actionStepId ? { body: { actionStepId: this.actionStepId }, what: 'equipmentDelete' } : null)
    },

    onDelete (response) {
      this.$events.emit(this.tableRef + '-refresh-table')
    }
  },

  computed: {
    qrCode: function () {
      return this.strIf(this.siteData.siteId, null, '|') +
        this.strIf(this.siteData.latitude, null, '|') +
        this.strIf(this.siteData.longitude, null, '|') +
        this.strIf(this.equip.organisation.shortName, null, '|') +
        this.strIf(this.equip.category, null, '|') +
        this.strIf(this.equip.type, null, '|') +
        this.strIf(this.equip.subType, null, '|') +
        this.strIf(this.equip.variant, null, '|') +
        this.strIf(this.equip.sector, null, '|') +
        this.strIf(this.equip.level, null, '|') +
        this.strIf(this.equip.diameter, null, '|') +
        this.strIf(this.equip.heightOnTower, null, '|') +
        this.strIf(this.equip.agl, null, '|') +
        this.strIf(this.equip.serialNo, null, '|') +
        this.strIf(this.equip.qty, null, '|') +
        this.strIf(this.formatDate(this.equip.installedOn))
    }

  },

  data () {
    return {
      tabs: 'equip-general',
      md: this.adding ? 24 : 12,
      catType: this.rowData ? [this.rowData.category, this.rowData.type, this.rowData.subType, this.rowData.variant] : [],
      disabled: true,
      fileName: this.rowData ? `${this.rowData.id}|${this.rowData.site.siteId}|${this.rowData.organisation.shortName}-${this.rowData.category}-${this.rowData.type}` +
        (this.rowData.subType ? `-${this.rowData.subType}` : '') +
        (this.rowData.variant ? `-${this.rowData.variant}` : '') +
        (this.rowData.installedOn ? `-${this.rowData.installedOn}` : '') +
        (this.rowData.qty ? `-QTY-${this.rowData.qty}` : '') : null,
      siteData: this.rowData && this.rowData.site ? this.rowData.site : {},
      equip: this.adding ? this.getTableStruct('assets') : (this.rowData ? this.rowData : this.getTableStruct('assets')),
      limits: null
    }
  },

  created () {

    if (!this.equip.site_id) {
      this.equip.site_id = this.siteId
    }

    if (!this.equip.owner_id) {
      this.equip.owner_id = this.ownerId
    }

    if (this.siteId) {
      this.fetchData('/sites/sharer-ids/' + this.siteId, this.getSharerIds)
    }

  },

  mounted () {
    if (this.adding) {
      this.disabled = false
      delete this.equip.id
    }

    if (!this.equip.site_id) {
      this.equip.site_id = this.siteId
    }

    if (!this.equip.owner_id) {
      this.equip.owner_id = this.ownerId
    }
  }

}
</script>

<stype scoped>
  .el-select {display: inline-block; width: 100%}
</style>
